import { Component, input, InputSignal } from '@angular/core';

export type FinePrintItemType = 'link' | 'tip' | 'footnote' | 'pagenote' | 'disclaimer' | 'custom';
/**
 * The Fine Print tip or disclaimer.
 */
@Component({
  selector: 'td-wb-fine-print-item',
  template: '<ng-content />',
  styleUrls: ['fine-print-item.component.scss']
})
export class FinePrintItemComponent {
  readonly itemType: InputSignal<FinePrintItemType | undefined> = input<FinePrintItemType | undefined>(undefined);
}
